import { campaignClickRepository } from '@/repositories/localStorage/campaignClickRepository'
import { groupClickRepository } from '@/repositories/localStorage/groupClickRepository'
import { mediaViewRepository } from '@/repositories/localStorage/mediaViewRepository'
import { ctaClickRepository } from '@/repositories/localStorage/ctaClickRepository'
import { circleOverlayShownRepository } from '@/repositories/localStorage/circleOverlayShownRepository';
import { introAnimationShownRepository } from '@/repositories/localStorage/introAnimationShownRepository';

const repositories = {
  campaignClick: campaignClickRepository,
  groupClick: groupClickRepository,
  mediaView: mediaViewRepository,
  ctaClick: ctaClickRepository,
  circleOverlay: circleOverlayShownRepository,
  introAnimation: introAnimationShownRepository
}
export const localStorageRepositoryFactory = {
  get: (key) => repositories[key]
}
